export default "__VITE_ASSET__DG5$WnTr__"